import { IncomeByPenname } from './IncomeByPenname'
import { withIncomeByPenname } from './withIncomeByPenname'

const Connected = withIncomeByPenname(IncomeByPenname)

export { Connected as IncomeByPenname }
